<template>
  <div class="container" :class="{ show: show }">
    <div v-if="toast" class="POItoast">
      {{ $t('poi_created_successfully') }}
    </div>
    <!-- <div class="d-flex justify-content-end">
      <div @click="onCancel" class="cursor-pointer">
        <IconCancel />
      </div>
    </div> -->

    <div class="d-flex justify-content-between align-items-center mb-4">
      <h4 class="poi-header pl-0 mb-0">{{ $t('points_of_interest') }}</h4>
      <div @click="onCancel" class="cursor-pointer d-flex align-items-center">
        <IconCancel />
      </div>
    </div>
    
    <div style="height: 60vh; min-height: 500px; overflow-y:auto" class="mt-3">
      <div
        :key="POI._id"
        v-for="POI in POI"
        class="device-container d-flex justify-content-between align-items-center mb-3 p-4"
      >
        <div>
          {{ POI.name }}
        </div>
        <div class="delete-poi" @click="deletepoi(POI._id)">
          {{ $t('delete') }}
        </div>
      </div>
    </div>
    <!-- <div class="form-group">
      <div class="d-flex justify-content-end">
        <button class="btn-maps">Create</button>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import IconCancel from "../components/Iconsvg/IconCancel";

export default {
  name: "ViewPOIList",
  components: {
    IconCancel,
  },
  props: {
    show: Boolean,
    toast: Boolean,
  },
  methods: {
    ...mapActions(["deletePOI", "fetchPOI"]),
    onCancel() {
      this.$emit("closeViewPOIList");
    },
    deletepoi(id) {
      this.$emit("delete-POI", id)
      // this.deletePOI(id).then(() => {
      //   this.fetchPOI().then(() => {
      //     console.log("fetched");
      //   });
      // });
    },
  },
  computed: {
    ...mapGetters(["POI"]),
  },
};
</script>

<style scoped>
.device-container {
  height: 50px;
  /* border-bottom: ; */
  box-shadow: 0px 1px 0px #e1e7ec;
}
.container {
  width: 0px;
  background: #fff;
  position: absolute;
  right: 0;
  top: 64px;
  height: calc(100% - 64px);
  z-index: 2000;
  padding: 28px 0;
  overflow: hidden;
  transition: 0.3s ease-out;
}
.container.show {
  width: 300px;
  padding: 28px 20px;
}
.action-summary {
  padding: 10px;
  background: #f2f5f7;
  margin-bottom: 26px;
}
.btn-maps {
  background: #f2f5f7;
  padding: 10px 23px;
  color: #30b24b;
  border: 1px solid #e1e7ec;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.delete-poi {
  font-style: italic;
  font-size: 14px;
  line-height: 18px;
  cursor: pointer;
  color: #2980b9;
}
.POItoast {
  width: 90%;
  margin: auto;
  padding: 20px;
  background: rgba(59, 173, 162, 0.17);
  border: 1.5px solid #213e7a;
  border-radius: 3px;
  margin-bottom: 20px;
}
.poi-header {
  padding-left: 20px;
  font-style: italic;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  color: #2980b9;
}
</style>
